import React from "react"

import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import {FieldConditionFormProps, FieldConditionRenderMode} from "../../../../render/condition/@types"
import Filter from "../../../../../manager/filters/manager/filter"
import FieldTaskUsers from "../users"
import {FieldConditionsDropdown_NotSetOption} from "../../../../conditions/dropdown";

// const debug = "FieldTaskUsers_ConditionForm"
const debug = false

export default function FieldTaskUsers_ConditionForm(props:FieldConditionFormProps) {

    const filter = props.condition as Filter
    const field = filter.field as FieldTaskUsers

    const onChangeType = (conditionType: ConditionType) => {
        props.condition.type = conditionType
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeValue = (value: any) => {
        props.condition.value = value
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const getOptions = async (): Promise<Option[]> => {
        switch (props.renderMode) {
            case FieldConditionRenderMode.FILTER_ITEMS_COLLECTION:
            case FieldConditionRenderMode.FILTER_COLLECTION:
                return await field.filterGetOptions(filter)

            case FieldConditionRenderMode.CONDITION:
            default:
                // doesn't apply
                return []
        }
    }

    return (
        <>
            <ConditionTypeSelector field    = {props.field}
                                   value    = {props.condition.type}
                                   onChange = {onChangeType}/>

            <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                   options                          = {field.filterGetAllOptions()}
                                   getPopoverOptions                = {getOptions}
                                   values                           = {props.condition.value}
                                   popoverContainerClasses          = "max-w-200"
                                   popoverScrollContainerClasses    = "max-h-200"
                                   isSearchable                     = {true}
                                   onChange                         = {onChangeValue}/>
        </>
    )
}